import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Etkinlik türü ekle/düzenle form şeması (023): nameTr zorunlu; nameEn opsiyonel. Sıra (SORT_INDEX) formda
 * yok — sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona otomatik atanır).
 */
export const eventTypeFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type EventTypeFormValues = z.infer<typeof eventTypeFormSchema>
